export default function () {
  return {
    'entityType': 'LOCATION_SETTINGS',
    'posDesign': {
      'entityType': 'POS_DESIGN',
      'virtualTicket': {
        'addItemsTo': 'TOP'
      }
    },
    'orderTypes': {
      'entityType': 'ORDER_TYPES',
      'nextTypeId': 12,
      'types': [
        {
          'id': 1,
          'entityType': 'ORDER_TYPE',
          'name': 'Dine In',
          'abbrev': '',
          'code': 'dine_in',
          'groupId': 1,
          'activePOS': true,
          'settings': {
            'requireTentNumber': true,
            'requireTableNumber': false,
            'requireCustomerName': false,
            'requirePhoneNumber': false,
            'requireCustomerLookup': false,
            'requireNumberOfPeople': false,
            'saveOpenTickets': true,
            'showInServerDetails': false
          }
        },
        {
          'id': 2,
          'entityType': 'ORDER_TYPE',
          'name': 'To Go',
          'abbrev': 'T',
          'code': 'to_go',
          'groupId': 1,
          'activePOS': true,
          'settings': {
            'requireTentNumber': false,
            'requireTableNumber': false,
            'requireCustomerName': true,
            'requirePhoneNumber': false,
            'requireCustomerLookup': false,
            'requireNumberOfPeople': false,
            'saveOpenTickets': false,
            'showInServerDetails': false,
            'curbside': 'OFF'
          }
        },
        {
          'id': 3,
          'entityType': 'ORDER_TYPE',
          'name': 'Drive Thru',
          'abbrev': '',
          'code': 'drive_thru',
          'groupId': 1,
          'activePOS': true,
          'settings': {
            'requireTentNumber': false,
            'requireTableNumber': false,
            'requireCustomerName': false,
            'requirePhoneNumber': false,
            'requireCustomerLookup': false,
            'requireNumberOfPeople': false,
            'saveOpenTickets': false,
            'showInServerDetails': false,
            'curbside': 'OFF'
          }
        },
        {
          'id': 4,
          'entityType': 'ORDER_TYPE',
          'name': 'Bar',
          'abbrev': '',
          'code': 'bar',
          'groupId': 1,
          'activePOS': true,
          'settings': {
            'requireTentNumber': false,
            'requireTableNumber': true,
            'requireCustomerName': false,
            'requirePhoneNumber': false,
            'requireCustomerLookup': false,
            'requireNumberOfPeople': false,
            'saveOpenTickets': true,
            'showInServerDetails': true
          }
        },
        {
          'id': 5,
          'entityType': 'ORDER_TYPE',
          'name': 'Table',
          'abbrev': '',
          'code': 'table',
          'groupId': 1,
          'activePOS': true,
          'settings': {
            'requireTentNumber': false,
            'requireTableNumber': true,
            'requireCustomerName': false,
            'requirePhoneNumber': false,
            'requireCustomerLookup': false,
            'requireNumberOfPeople': true,
            'saveOpenTickets': true,
            'showInServerDetails': true
          }
        },
        {
          'id': 7,
          'entityType': 'ORDER_TYPE',
          'name': 'Delivery',
          'abbrev': 'D',
          'code': 'delivery',
          'groupId': 2,
          'activePOS': true,
          'settings': {
            'requireTentNumber': true,
            'requireTableNumber': true,
            'requireCustomerName': true,
            'requirePhoneNumber': true,
            'requireCustomerLookup': true,
            'requireNumberOfPeople': true,
            'saveOpenTickets': true,
            'showInServerDetails': true
          }
        },
        {
          'id': 8,
          'entityType': 'ORDER_TYPE',
          'name': 'Eat In',
          'abbrev': 'E',
          'code': 'eat_in',
          'groupId': 2,
          'activePOS': true,
          'settings': {
            'requireTentNumber': false,
            'requireTableNumber': false,
            'requireCustomerName': true,
            'requirePhoneNumber': true,
            'requireCustomerLookup': false,
            'requireNumberOfPeople': false,
            'saveOpenTickets': true,
            'showInServerDetails': false
          }
        },
        {
          'id': 9,
          'entityType': 'ORDER_TYPE',
          'name': 'Pick Up',
          'abbrev': 'P',
          'code': 'pick_up',
          'groupId': 2,
          'activePOS': true,
          'settings': {
            'requireTentNumber': false,
            'requireTableNumber': false,
            'requireCustomerName': true,
            'requirePhoneNumber': true,
            'requireCustomerLookup': false,
            'requireNumberOfPeople': false,
            'saveOpenTickets': true,
            'showInServerDetails': false,
            'curbside': 'OFF',
            'thirdPartyOrdersClosed': false
          }
        }
      ]
    },
    'promiseTimes': {
      'byOrderType': [
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 1,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        },
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 2,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        },
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 3,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        },
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 4,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        },
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 5,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        },
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 6,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        },
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 7,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        },
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 8,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        },
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 9,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        },
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 10,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        },
        {
          'entityType': 'ORDER_TYPE_PROMISE_TIME',
          '$identifier': 'orderType',
          'orderType': 11,
          'minTime': 10,
          'maxTime': 90,
          'allowOnlineOrdersDueAtOpen': true,
          'allowOnlineOrdersPlacedAtClose': true
        }
      ],
      'byDayPart': [
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '962fbe19-7e76-47d5-b995-4857e628d279',
          'storeShift': 1,
          'orderType': 1,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '6b5e360d-0bf8-4f2d-b97a-a7115f1333ba',
          'storeShift': 2,
          'orderType': 1,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': 'b898ac54-3aa0-42d5-9f7b-c45f93968146',
          'storeShift': 3,
          'orderType': 1,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': 'dca763c1-f56f-462f-b574-9f6937e0744d',
          'storeShift': 1,
          'orderType': 2,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': 'd2f0090c-5145-446d-93b3-69c8194bf12a',
          'storeShift': 2,
          'orderType': 2,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '39a542cd-461e-402f-b501-5188ed576c97',
          'storeShift': 3,
          'orderType': 2,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '875c69ec-b1f6-4ca5-b503-f2706e01e06f',
          'storeShift': 1,
          'orderType': 3,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '1fa16383-d028-46d5-9687-e12ca6ac867b',
          'storeShift': 2,
          'orderType': 3,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '2c943002-082d-41d5-b2f8-713ecc3163e8',
          'storeShift': 3,
          'orderType': 3,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '52a8c1a9-112f-4710-b37c-a66cb0e934ad',
          'storeShift': 1,
          'orderType': 4,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '68dd1f90-3406-4731-ade8-c07ad32db1bf',
          'storeShift': 2,
          'orderType': 4,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '90db8f04-c118-49df-b622-66fd55562b16',
          'storeShift': 3,
          'orderType': 4,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '5d050064-ba94-4bf9-953e-f7ca88f2a856',
          'storeShift': 1,
          'orderType': 5,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': 'ece56681-6db6-43a9-8df7-e94f389b38bd',
          'storeShift': 2,
          'orderType': 5,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '3eff8649-7a72-40c0-b722-a342b3c91fce',
          'storeShift': 3,
          'orderType': 5,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': 'da016fee-9275-4eb6-abc9-678dc170e19c',
          'storeShift': 1,
          'orderType': 6,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '447ceb25-1fa2-4155-9175-67baf42c6ec1',
          'storeShift': 2,
          'orderType': 6,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': 'c155536a-afb0-44eb-8af0-ab3629c7de45',
          'storeShift': 3,
          'orderType': 6,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': 'df2f02f1-7c0a-4bf2-87a9-2adc3558f422',
          'storeShift': 1,
          'orderType': 7,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '5a664b11-e217-4cad-83b9-483efd0f0f95',
          'storeShift': 2,
          'orderType': 7,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': 'dd9de744-2dbc-4f03-938c-9edc462fd199',
          'storeShift': 3,
          'orderType': 7,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '2ecf4b92-78f3-47cc-ae14-533fcb3c5d70',
          'storeShift': 1,
          'orderType': 8,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '0e3e139c-ab08-44c6-9b8f-0a4dda2c7e55',
          'storeShift': 2,
          'orderType': 8,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '7a9a5f89-b355-4c93-a28f-014826f032e7',
          'storeShift': 3,
          'orderType': 8,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': 'dc2d3f45-c574-4840-8949-8b4b3ac0b416',
          'storeShift': 1,
          'orderType': 9,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '12e44bac-4331-4ea9-b019-de774b343c6c',
          'storeShift': 2,
          'orderType': 9,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '6078bef9-078f-4194-b399-107cda9c1000',
          'storeShift': 3,
          'orderType': 9,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '290c4eae-d4d2-49e8-9996-dcc5febe0ff8',
          'storeShift': 1,
          'orderType': 10,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '72e5e51e-0726-4651-a503-74061b34476b',
          'storeShift': 2,
          'orderType': 10,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '464400c9-ecde-4c67-a71e-1b5bdcf18fe0',
          'storeShift': 3,
          'orderType': 10,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '18e677aa-10b5-4569-a25c-f6a5fa161ca0',
          'storeShift': 1,
          'orderType': 11,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': '50ca70c3-202e-4bba-9e17-76b07d222dd1',
          'storeShift': 2,
          'orderType': 11,
          'default': 30
        },
        {
          'entityType': 'DAY_PART_PROMISE_TIME',
          'id': 'b306d15a-7d75-4dc4-aa4a-64418e89745d',
          'storeShift': 3,
          'orderType': 11,
          'default': 30
        }
      ]
    },
    // Documentation on file Location Settings Blob.js
    'deferredOrders': {
      'entityType': 'DEFERRED_ORDERS',
      'leadTime': 2700,
      'allowDeferredOnlineOrders': true,
      'maxOrderLeadDays': 14,
      'minOrderLeadTime': 2700,
      'minOrderLeadUnit': 'MINUTES',
      'reportDeferredRevenueAt': 'ORDER_TIME',
      'printToKitchenRightAway': true,
      'advancedExtraPrint': 'NONE',
      'printer': null, // entityType PHYSICAL_PRINTER id - null for default printer
      'printTime': 32400,
      'printOrdersWithinDays': null
    },
    'deliverySettings': {
      'orderMinimum': {
        'enabled': false,
        'value': '0.00'
      },
      'excludeChargeFromSalesTotal': false,
      'chargeCustomerMode': 'NO_CHARGE',
      'flatFeeAmount': '0.00',
      'percentageBeforeCpnTax': '0.00',
      'percentageAfterCpnTax': '0.00',
      'virtualZones': []
    },
    // Documentation on file Location Settings Blob.js
    'deliveryArea': {
      'enforceInPos': true,
      'zones': []
    },
    'tenderTypes': [
      {
        entityType: 'TENDER_TYPE',
        id: 1,
        name: 'Cash',
        min: {
          enabled: true,
          amount: '0.00'
        },
        max: {
          enabled: false,
          amount: '0.00'
        },
        maxChange: {
          enabled: false,
          amount: '0.00'
        },
        openDrawer: true,
        requireLookup: false,
        availableOnline: true,
        disabled: false,
        isDefault: true
      },
      {
        entityType: 'TENDER_TYPE',
        id: 2,
        name: 'Check',
        min: {
          enabled: true,
          amount: '0.00'
        },
        max: {
          enabled: false,
          amount: '0.00'
        },
        maxChange: {
          enabled: true,
          amount: '0.00'
        },
        openDrawer: false,
        requireLookup: false,
        availableOnline: true,
        disabled: true
      },
      {
        entityType: 'TENDER_TYPE',
        id: 4,
        name: 'Visa',
        min: {
          enabled: true,
          amount: '0.00'
        },
        max: {
          enabled: false,
          amount: '0.00'
        },
        maxChange: {
          enabled: false,
          amount: '0.00'
        },
        openDrawer: false,
        requireLookup: false,
        availableOnline: true,
        disabled: false
      },
      {
        entityType: 'TENDER_TYPE',
        id: 5,
        name: 'MasterCard',
        min: {
          enabled: true,
          amount: '0.00'
        },
        max: {
          enabled: false,
          amount: '0.00'
        },
        maxChange: {
          enabled: false,
          amount: '0.00'
        },
        openDrawer: false,
        requireLookup: false,
        availableOnline: true,
        disabled: false
      },
      {
        entityType: 'TENDER_TYPE',
        id: 6,
        name: 'Discover',
        min: {
          enabled: true,
          amount: '0.00'
        },
        max: {
          enabled: false,
          amount: '0.00'
        },
        maxChange: {
          enabled: false,
          amount: '0.00'
        },
        openDrawer: false,
        requireLookup: false,
        availableOnline: true,
        disabled: false
      },
      {
        entityType: 'TENDER_TYPE',
        id: 7,
        name: 'American Express',
        min: {
          enabled: true,
          amount: '0.00'
        },
        max: {
          enabled: false,
          amount: '0.00'
        },
        maxChange: {
          enabled: false,
          amount: '0.00'
        },
        openDrawer: false,
        requireLookup: false,
        availableOnline: true,
        disabled: false
      },
      {
        entityType: 'TENDER_TYPE',
        id: 9,
        name: 'Gift',
        min: {
          enabled: true,
          amount: '0.00'
        },
        max: {
          enabled: false,
          amount: '0.00'
        },
        maxChange: {
          enabled: false,
          amount: '0.00'
        },
        openDrawer: false,
        requireLookup: false,
        availableOnline: true,
        disabled: false,
        requireGiftCertificate: false
      },
      {
        entityType: 'TENDER_TYPE',
        id: 10,
        name: 'Account',
        min: {
          enabled: true,
          amount: '0.00'
        },
        max: {
          enabled: false,
          amount: '0.00'
        },
        maxChange: {
          enabled: false,
          amount: '0.00'
        },
        openDrawer: false,
        requireLookup: false,
        availableOnline: true,
        disabled: false
      }
    ],
    'invalidAddresses': [],
    'tipsSettings': {
      'entityType': 'TIPS_SETTINGS',
      'allowTipsPOS': true,
      'allowTipsOnline': true,
      'autoGratuityOnPOSOrder': {
        'enabled': true,
        'incomeType': 'NET',
        'chargePercentage': '0.00',
        'minPeoplePerOrder': 8
      }
    },
    'cashManagement': {
      entityType: 'CASH_MANAGEMENT',
      autoDepositCreditBatch: true,
      ticketNumbers: {
        startAt: 1,
        reset: {
          mode: 'DAILY', // DAILY, AFTER_NUMBER
          resetAfter: 9999
        }
      },
      startingBalance: '0',
      displayExpectedTender: 'DISPLAY_AFTER_ENTRY', // DISPLAY, DISPLAY_AFTER_ENTRY, HIDE
      cashTransfers: {
        DRIVER_BANK: 'MAIN_SAFE',
        DRIVER_DROP: 'MAIN_SAFE',
        DRIVER_CLOSE: 'MAIN_SAFE',
        SERVER_BANK: 'MAIN_SAFE',
        SERVER_CLOSE: 'MAIN_SAFE'
      },
      detailedCashManagement: true,
      overShortReasons: [],
      voidReasons: [],
      customVoidReason: true
    },
    'paidInOutAccounts': [
      {
        'entityType': 'PAID_IN_OUT_ACCOUNT',
        'id': 1,
        'name': 'Delivery',
        'paidIns': true,
        'paidOuts': false,
        'reportOnPayroll': false,
        'payrollCode': '',
        'disabled': false
      },
      {
        'entityType': 'PAID_IN_OUT_ACCOUNT',
        'id': 2,
        'name': 'Repairs',
        'paidIns': true,
        'paidOuts': false,
        'reportOnPayroll': false,
        'payrollCode': '',
        'disabled': false
      },
      {
        'entityType': 'PAID_IN_OUT_ACCOUNT',
        'id': 3,
        'name': 'Supplies',
        'paidIns': true,
        'paidOuts': false,
        'reportOnPayroll': false,
        'payrollCode': '',
        'disabled': false
      },
      {
        'entityType': 'PAID_IN_OUT_ACCOUNT',
        'id': 4,
        'name': 'Smallwares',
        'paidIns': true,
        'paidOuts': false,
        'reportOnPayroll': false,
        'payrollCode': '',
        'disabled': false
      },
      {
        'entityType': 'PAID_IN_OUT_ACCOUNT',
        'id': 5,
        'name': 'Event Deposit',
        'paidIns': true,
        'paidOuts': false,
        'reportOnPayroll': false,
        'payrollCode': '',
        'disabled': false
      }
    ],
    'tableSettings': {
      'ticketsCloseAtRegister': true,
      'serverKeepsTips': true,
      'serverKeepsAutoGratuity': true,
      'requireEnterSection': false,
      'requirePeopleNumber': true,
      'issueServerBankOfAmount': {
        'enabled': false,
        'value': '0.00'
      },
      'autoClearAfterSettle': false,
      'tableAlertTimesInMins': {
        'afterSeatedWithNoOrder': 10,
        'afterOrdered': 90,
        'afterSettled': 15
      }
    },
    'barSettings': {
      'barTabs': true,
      'preAuthMode': 'PRE_AUTH_ONE',
      'preAuthAmountIncrement': '25'
    },
    'driverManagement': {
      'requireStartingDriverBank': {
        'enabled': false,
        'amount': '0.00'
      },
      'reprintCustomerReceiptWhenOrderAssigned': false,
      'enforceMaxOrdersPerRun': {
        'enabled': false,
        'amount': 0
      },
      'requireDriverDrop': 'NONE', // NONE | DROP_AT_LIMIT | AFTER_EACH_DELIVERY | RETURN_AND_PAY
      'driverDropRequiredLimit': '0.00',
      'driverLatenessCriteria': {
        // in minutes
        'forOneOrder': 20, // minutes
        'forTwoOrders': 30, // minutes
        'forThreeOrders': 45 // minutes
      }
    },
    'stations': [],
    displays: [],
    printing: {
      entityType: 'PRINTING',
      printers: [],
      templates: [
        {
          id: 1,
          name: 'Customer Receipt',
          entityType: 'PRINTING_TEMPLATE',
          itemGrouping: 'PRINT_AS_ORDERED',
          itemSorting: 'ITEM_SORT_ORDER',
          tagAlong: { atBottom: false },
          voidItemsIncluded: true
        },
        {
          id: 2,
          name: 'Production Ticket',
          entityType: 'PRINTING_TEMPLATE',
          itemGrouping: 'PRINT_AS_ORDERED',
          itemSorting: 'ITEM_SORT_ORDER',
          tagAlong: { atBottom: false },
          voidItemsIncluded: true
        },
        {
          id: 3,
          name: 'Condensed Receipt',
          entityType: 'PRINTING_TEMPLATE',
          itemGrouping: 'PRINT_AS_ORDERED',
          itemSorting: 'ITEM_SORT_ORDER',
          tagAlong: { atBottom: false },
          voidItemsIncluded: false
        }
      ],
      otherOptions: {
        entityType: 'PRINTING_OTHER_OPTIONS',
        individualSubtotal: false,
        nothingToPrepare: false,
        reprintKitchenVoids: true,
        signatureLine: false,
        reprintKitchenChanged: false,
        reprintKitchenRevisions: false,
        addressOnDeliveries: true,
        fontSizeForMisc: 'MEDIUM'
      }
    },
    creditAndGiftSettings: {
      accountSettings: {
        paymentProcessor: 'WORLD_PAY_ELEMENT', // WORLD_PAY_ELEMENT | MERCURY_PAY | OPEN_EDGE | CAYAN
        processors: {
          'WORLD_PAY_ELEMENT': {
            name: 'WorldPay | Element',
            acceptorId: '',
            accountId: '',
            accountToken: '',
            terminalId: '',
            emv: {
              tipType: 'PERCENTAGE', // PERCENTAGE | AMOUNT
              tipAmounts: [], // ['20', '100']
              customTipSupported: true,
              bypassOfPinPadAllowed: false,
              displayTotalThenTip: false,
              confirmTotalAmountScreenDisplayed: false
            }
          },
          'MERCURY_PAY': {
            name: 'Mercury Pay',
            cardPresentMerchantId: '',
            cardNotPresentMerchantId: '',
            url: 'w1.mercurycert.net',
            alternateUrl: '',
            password: ''
          },
          'OPEN_EDGE': {
            name: 'Open Edge',
            accountToken: '',
            url: ''
          },
          'CAYAN': {
            name: 'Cayan',
            creditProcessor: '', // MERCHANT_CREDIT_PROCESSOR entity id
            merchantKey: '',
            merchantName: '',
            merchantSiteId: ''
          }
        },
        merchantCreditProcessors: [
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Alliance Data Systems, Inc.',
            'id': 'ADSI'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'American Express',
            'id': 'AMEX'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'BuyPass, Inc.',
            'id': 'BPAS'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'CardSystems',
            'id': 'MVRK'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Concord / EFS',
            'id': 'CCRD'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'ECHO',
            'id': 'ECHO'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'FDMS Nashville / Envoy',
            'id': 'FDCN'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'FDMS North / Cardnet',
            'id': 'CES'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'FDMS Omaha / FDR',
            'id': 'FDC'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'FDMS South / NaBanco',
            'id': 'NB'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Fifth-Third Bank - St. Pete',
            'id': 'BPS'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'First Hawaiian',
            'id': 'FHAW'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'First Horizon',
            'id': 'FTMS'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Global Payment-East',
            'id': 'NDC'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Global Payments-Central',
            'id': 'MAPP'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Heartland Payment Systems',
            'id': 'HPTS'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Lynk Systems, Inc.',
            'id': 'LYNK'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'National Processing Company',
            'id': 'NPC'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'NOVA',
            'id': 'NOVA'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Paymentech',
            'id': 'GSAR'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Royal Bank of Canada',
            'id': 'RBOC'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Vital',
            'id': 'VISA'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'Givex',
            'id': 'GVEX'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'ValueTec',
            'id': 'VTEC'
          },
          {
            'ENTITY_TYPE': 'MERCHANT_CREDIT_PROCESSOR',
            'name': 'ValueLink',
            'id': 'VLNK'
          }
        ]
      },
      giftCardProcessor: {
        paymentProcessor: 'MERCURY_PAY', // WORLD_PAY_ELEMENT | MERCURY_PAY | OPEN_EDGE | CAYAN
        processors: {
          'WORLD_PAY_ELEMENT': {
            name: 'WorldPay | Element',
            storeCardId: '',
            storeCardPassword: ''
          },
          'MERCURY_PAY': {
            name: 'Mercury Pay',
            cardPresentMerchantId: '',
            cardNotPresentMerchantId: '',
            url: 'w1.mercurycert.net',
            alternateUrl: '',
            password: ''
          },
          'OPEN_EDGE': {
            name: 'Open Edge',
            merchantId: '',
            url: ''
          },
          'CAYAN': {
            name: 'Cayan',
            merchantKey: '',
            merchantName: '',
            merchantSiteId: ''
          }
        }
      },
      securitySettings: {
        cvvKeyed: true,
        cvvWeb: true,
        cvvGift: false,
        archive: 1, // days
        minimumAvsResultAllowed: 'UNKNOWN', // UNKNOWN | NO_MATCH | ADDRESS_ONLY_MATCH | ZIP_ONLY_MATCH | MATCH
        minimumAvsResultAllowedWeb: 'UNKNOWN', // UNKNOWN | NO_MATCH | ADDRESS_ONLY_MATCH | ZIP_ONLY_MATCH | MATCH
        minimumCvvResultAllowed: 'UNKNOWN', // UNKNOWN | NO_MATCH | MATCH
        signatureRequirement: 'DEFAULT', // DEFAULT | ALWAYS | NEVER | USE_THRESHOLD
        signatureThreshold: '0.00',
        allowableExcessMultiplier: '0.5'
      },
      printSettings: {
        printedIfBelowSignatureThreshold: true,
        creditReceipts: '1',
        giftReceipts: '1',
        creditTipLine: false,
        giftTipLine: false,
        printTipCalculator: false,
        presetPercentages: [],
        creditFontSize: 'LARGE', // SMALL | MEDIUM | LARGE
        printDeliveryReceipt: 'BOTH' // ORDER | DISPATCH | BOTH
      }
    }
  }
}
